import React from 'react'
import { Label } from 'reactstrap'
import { Button, Input } from 'antd'
import './StepThreePage.scss'
import { ArrowRightOutlined } from '@ant-design/icons'

const StepThreePage = ({ next }) => {
    const { TextArea } = Input;
    return (
        <div className='step3-section'>
            <h1>What <strong>progress </strong> have you made?</h1>
            <form>
                <div className="form-field">
                    <Label>What early steps have you taken?</Label>
                    <TextArea rows={6} className="textarea-field-input"
                        placeholder="50+ customer interviews and prototype development.  "
                        name="what-steps-taken"
                        type="textarea" />
                </div>
                <Button
                    // loading={authLoading}
                    // disabled={!isEnabled}
                    onClick={next}
                    className="continue-button"
                >
                    Continue <ArrowRightOutlined />
                </Button>
            </form>
        </div>
    )
}

export default StepThreePage